export default __webpack_public_path__ + "static/media/external-link.84835f5e.svg";